module.exports = __webpack_public_path__ + "media/images/guideline/H_02-468c5ab3566f23bf22750676fa57316a.jpg";